﻿export const ProductType = Core.Booking.ProductType;
export const CrossSellType = Core.Booking.CrossSellType;
export const CarHireSortOrder = Core.CarHire.SortOrder;
